import type { EmblemSetType } from "@/lib/domain/EmblemSet";
import { useHTTP, useHTTPQueryWithCursor } from "@/lib/http";
import type { PaginatedResponseModel } from "@/lib/http";
import type { EmblemModel } from "@/features/emblems/api/models/EmblemModel";

export const useEmblems = (set: EmblemSetType) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["emblems", set],
		queryFn: ({ pageParam = 0 }) => http<PaginatedResponseModel<EmblemModel>>({
			method: "GET",
			url: `/emblem?cursor=${pageParam}&set=${set}`
		})
	});
};
